import React, { useState, useEffect } from "react";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Table, Image, Button } from "react-bootstrap";
import SelectFilter from "../../../reusableComponents/selectFilter";
import { NavLink, useHistory } from "react-router-dom";
import Switch from "react-switch";
import BasicPagination from "../../../Pagination/Pagination";
import {
  getAllCateogryForIcons,
  getSubCateogryWithCategoryId,
} from "../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { amApi } from "../../../../api/apiHelper";
import { errorAlert, successAlert } from "../../../../function/alert";
import { Toggle } from "../../superAdminReusable/reusableSuperAdminButton/Toggle";
import SuperAdminDeletePos from "./DeletePos";
import TestConnection from "./TestConnection";
import {OTPVerification} from "./DeletePos";

function PosDetails(props) {
  const [iconsData, setIconsData] = useState();

  const [page, setPage] = useState(1);

  const [start, setStart] = useState(0);

  const [end, setEnd] = useState(10);

  const history = useHistory();

  const onSuccess = (data) => {
    console.log(data);
    setIconsData(data);
  };

  const fetchData = async () => {
    try {
      const response = await amApi.get("admin/pos");
      if (response && response.data) {
        setIconsData(response.data);
        console.log(response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  
  useEffect(() => {
    fetchData(); 
  }, []);


  const ChangeStatus = async (status,_id) => {
    try {
      let reqdata   = await amApi.post(`/admin/pos`, { status: !status,pos_config_id: _id});
      if(reqdata.data){
        successAlert("updated succesfully");
        fetchData();    
      }  
    } catch (err) {
      errorAlert('Something Went Wrong, try again later');
    }
  }


  const RenderTableBody = (iconsData,ChangeStatus,fetchData) => {
    return (
      <>
        {iconsData &&
          iconsData?.slice(start, end).map((data, index) => (
            <React.Fragment key={data?._id}>
              <TableBody data={data}  ChangeStatus={ChangeStatus} fetchData={fetchData} />
            </React.Fragment>
          ))}
      </>
    );
  };

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="Reports" />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Define Pos
                  <br />
                </div>
                <div className="col-6 text-right">
                  <NavLink
                    to="/addPos"
                    className="mr-4 px-5 py-2 btn addBtnRed f12-700"
                    style={{ color: "#f26856" }}
                  >
                    Configure New POS
                  </NavLink>
                </div>
              </div>
              <div className="row">
                <div className="col-4 d-flex">
                  <Image
                    //   onClick={() =>
                    //     setState({
                    //       ...state,
                    //       showSearch: !state.showSearch,
                    //     })
                    //   }
                    alt="filter"
                    title="search"
                    width="80px"
                    src={require("../../../../assets/images/iconButton/newsearchicon.svg")}
                  />
                  <div
                    className="f10-400"
                    align="center"
                    // onClick={() => showFilter(!filter)}
                  >
                    <img
                      src={require("../../../../assets/images/iconButton/filterbtn.svg")}
                      width="80px"
                    />
                    <br />
                  </div>
                  <div
                    className="f10-400"
                    align="center"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    // onClick={props.handleClick}
                  >
                    <img
                      src={require("../../../../assets/images/iconButton/sortbtn.svg")}
                      width="80px"
                    />
                    <br />
                  </div>
                  <div className="f10-400" align="center">
                    <img
                      src={require("../../../../assets/images/iconButton/downloadbtn.svg")}
                      width="80px"
                      alt="icon"
                    />
                    <br />
                  </div>
                </div>
                <div className="col-5"></div>
                <div className="col-3 d-flex align-items-center justify-content-end">
                  <div className="mr-3">
                    <SelectFilter onDateChange={() => {}} />
                  </div>
                </div>
              </div>
              <hr />
              <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                {/* <div className="col-12 p-0 user-table-reusable-superadmin table-responsive"> */}
                <Table className="">
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <td style={{ width: "15%" }} className="f12-400 ml-2">
                        POS
                      </td>
                      <td style={{ width: "20%" }} className="f12-400">
                        Support/ <br />
                        Do not Support
                      </td>
                      <td style={{ width: "20%" }} className="f12-400">
                        Running Status
                      </td>
                      <td style={{ width: "20%" }} className="f12-400">
                        Environment
                      </td>
                      <td style={{ width: "20%",textAlign:"center" }} className="f12-400">
                        Action
                      </td>
                    </tr>
                  </thead>
                  {RenderTableBody(iconsData,ChangeStatus,fetchData)}
                </Table>
                <div className="row w-100">
                  <div className="col-12">
                    {iconsData && iconsData.length !== 0 ? (
                      <BasicPagination
                        totalRecords={iconsData.length}
                        limit={10}
                        batch={page}
                        onBatchChange={(e) => handleBatchChange(e)}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const TableBody = ({ data,ChangeStatus,fetchData, ...props }) => {


  const history = useHistory();

  const [TrDetail, setTrDetail] = useState(false);

  const showTr = () => setTrDetail(!TrDetail);

  const token = props?.auth?.user?.accessToken;

  const editPos = (id) => {
    history.push({
      pathname: `addPos/${id}`,
      state: {
        edit: true,
        pos_id: id,
      },
    });
  };

  const testConnectionObj = { 
    "base_url": data.environment === "STAGING" ? data.staging_config.base_url : data.production_config.base_url,
    "app_key": data.environment === "STAGING" ? data.staging_config.app_key : data.production_config.app_key,
    "app_secret": data.environment === "STAGING" ? data.staging_config.app_secret : data.production_config.app_secret ,
    "access_token": data.environment === "STAGING" ? data.staging_config.access_token : data.production_config.access_token, 
}

const onSuccessSetRunningStatus = (data) => {
  fetchData();
}

const onSuccessDeletion = () => {
  fetchData();
}

  return (
    <tbody className="w-100 super-admin-all-vendor-main-table-body">
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr
                className="sd_body_table-row super-admin-list-icon-image"
                onClick={showTr}
              >
                <td
                  style={{
                    width: "15%",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <Image
                      fluid
                      //src={require("../../../../assets/images/Icon/bakery.png")}
                      src={data?.pos_config_id?.icon}
                      className="inside-icon-image m-0"
                      alt="Icon"
                    />
                  </div>
                  <div className="mx-1">
                    <h5 className="font_16_m ">
                      {data?.pos_config_id?.title || ""}
                    </h5>
                  </div>
                </td>
                <td style={{ width: "20%" }}>
                  <Toggle
                    toggleFunction={() => ChangeStatus(data?.status,data?.pos_config_id?._id)}
                    className="my-3"
                    checked={data?.status}
                  />
                 
                </td>
                <td style={{ width: "20%" }}>
                <div className={`f12-500 ${data.runningStatus === "1" ? 'greendot' : 'reddot'} d-flex align-items-center justify-content-start`}>
                    {data.runningStatus === "1" ? "Active" : "Inactive"}
                   
                  </div>
                </td>
                <td style={{ width: "20%" }}>
                  <div className="f12-500  d-flex align-items-center justify-content-start pl-3">
                    {data?.environment =="STAGING" ? 'SandBox' :'Production'}
                  </div>
                </td>
                <td style={{ width: "30%" }}>
                  <div className="f12-500">
                    <div className="f12-400 d-flex">
                      {!data?.mark_for_deletion ? (<>
                        <SuperAdminDeletePos id={data?.pos_config_id?._id} deletestatus={data?.mark_for_deletion} token={token} email={data?.email}  onSuccess={onSuccessDeletion}/>
                        {/* <OTPVerification /> */}
                      </>) : (
                        <><div className="f12-500" style={{color:" #ee3a23" }}> Have been marked for Deletion*</div></>
                      ) }
                     
                      <Button
                        variant="link"
                        className="enIconBtn mr-3"
                        onClick={() => editPos(data?.pos_config_id?._id)}
                      >
                        <Image
                          src={require("../../../../assets/images/UserManagement/pencil.svg")}
                          alt="Edit"
                          title="Edit"
                          fluid
                        />
                      </Button>
                      <TestConnection  formData = {testConnectionObj} data={data} onSuccess={onSuccessSetRunningStatus}/>
                     
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

// export default PosDetails;

PosDetails.propTypes = {
  auth: PropTypes.object.isRequired,
  getAllCateogryForIcons: PropTypes.func.isRequired,
  getSubCateogryWithCategoryId: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  getAllCateogryForIcons,
  getSubCateogryWithCategoryId,
})(PosDetails);
